import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles((theme) => ({
  paper: {
    minWidth: "468px",
    [theme.breakpoints.down("xs")]: {
      minWidth: "100%",
    },
  },
  subtitle: {
    color: theme.palette.primary.dark,
    fontSize: "1.4rem",
  },

  saveButton: {
    marginLeft: theme.spacing(2),
  },
  avatarContainer: {
    backgroundColor: "#E2E7EF",
    width: "175px",
    height: "175px",
    position: "relative",
  },
  avatar: {
    width: "121px",
    height: "121px",
    fontSize: "50px",
  },
  textfield: {
    marginBottom: theme.spacing(1.5),
  },
  pencilIcon: {
    color: theme.palette.primary.dark,
    position: "absolute",
    right: "5px",
    top: "5px",
  },
  formHelperText: {
    marginLeft: "0px",
    position: "absolute",
    bottom: "-20px",
  },
  buttonLabel: {
    minWidth: "36px",
  },
  dobDatePicker: {
    color: theme.palette.error.main,
    "& .MuiInputBase-root": {
      "& .MuiOutlinedInput-notchedOutline": {
        border: `1px solid ${theme.palette.error.main}`,
      },
    },
    "& .MuiInputLabel-root": {
      color: theme.palette.error.main,
    },
    "& .MuiFormHelperText-root": {
      "& .MuiError": {
        marginLeft: "0px",
        position: "absolute",
        bottom: "-20px",
      },
    },
  },
}))

export default styles
